<template>
    <div>

        <el-card class="detail-card">

            <ul>
                <li>
                    <p v-for='item of tabActive' :key='item.path'>
                        <router-link :to="{ path: item.path,
                                        query: { parentNumber:detail.serialNumber, callback: getDetail, parentParams: parentParams }}">
                            <el-button type="primary">{{item.title}}</el-button>
                        </router-link>
                    </p>
                </li>
            </ul>

            <el-row>
                <el-col :span="6"><label>编号：</label>{{ detail.serialNumber }} -- {{ status }}</el-col>
                <el-col :span="18"><label>标题：</label>{{ detail.title }}</el-col>
            </el-row>

            <el-row>
                <el-col :span="6"><label></label>{{ detail.updateTime }}</el-col>
                <el-col :span="18">
                    <label>请求人：</label>
                    {{ detail.owner && (detail.owner.name || '')
                + (detail.owner.department ? ' / ' : '' )
                + (detail.owner.department || '')
                    }}</el-col>
            </el-row>

        </el-card>

        <div class="tab-card">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane :label="item.name" :name="item.index" v-for="item in tabViews" :key="item.index">
                    <div v-loading="loading" v-if="loading" style="width:100%;height:300px;"></div>
                    <keep-alive v-if="!loading">
                        <component :is="currentView"
                                   :eventList="eventList"
                                   :problemList="problemList"
                                   :changeList="changeList"
                                   :deployList="deployList"
                                   :detail="detail"
                                   :callback='getDetail'></component>
                    </keep-alive>
                </el-tab-pane>
            </el-tabs>
        </div>

    </div>
</template>

<script>
    import services from './configuration.services'
    import commonService from "../../services/common.service"

    import detailForm from "./detailForm.vue"                       // 表单明细
    import configProperties from './configProperties'               //配置属性
    import detailRelation from "./detailRelation.vue"               // 配置关系
    import HistoricEdition from "./detailHistoricEdition.vue"       // 历史版本
    import OperationRecord from "./detailOperationRecord.vue"       // 操作记录
    // import PushRecord from "./detailPushRecord.vue"                 // 推送记录
    import RecommendKnowledge from "./RecommendKnowledge.vue"       // 推荐知识
    import SquareYards from "./SquareYards.vue"                     // 条形码
    import RelevancyEvent from "../common/detail/detailRelevancyEvent.vue";        // 关联事件
    import RelevancyQue from "../common/detail/detailRelevancyQue.vue";            // 关联问题
    import RelevancyChange from "../common/detail/detailRelevancyChange.vue";      // 关联变更
    import RelevancyIssue from "../common/detail/detailRelevancyIssue.vue";        // 关联发布

    export default {

        components: {
            detailForm,
            configProperties,
            detailRelation,
            HistoricEdition,
            OperationRecord,
            RecommendKnowledge,
            SquareYards,
            RelevancyEvent,
            RelevancyChange,
            RelevancyQue,
            RelevancyIssue
        },
        computed: {
            serialNumber() {
                return this.$route.query.serialNumber
            },
            // 应该渲染的组件
            currentView(){
                return this.tabViews[this.index].index
            },

            // 字典
            dictionary(){
                return this.$store.state.dictionary
            },
            // 事件分类id
            eventType(){
                return this.$store.state.caseType.event;
            },
            // 问题分类id
            problemType(){
                return this.$store.state.caseType.problem;
            },
            // 变更分类id
            changeType(){
                return this.$store.state.caseType.change;
            },
            // 发布分类id
            deployType(){
                return this.$store.state.caseType.deploy;
            },
            // 配置项状态
            cmdbStatus(){
                return this.dictionary.cmdb_status
            },

            // 传过去提交为
            parentParams() {
                // this.detail.toCmdb && this.detail.toCmdb.push({
                //     serialNumber: this.detail.serialNumber,
                //     title:this.detail.title
                // })

                return {
                    company: this.detail.company && `${this.detail.company.id}`, // 公司
                    title: this.detail.title, // 标题
                    description: this.detail.description, // 描述
                    attachment: this.detail.attachment, // 附件
                    toChange: this.detail.toChange, // 关联变更
                    toEvent: this.detail.toEvent, // 关联事件
                    toProblem: this.detail.toProblem, // 关联问题
                    toDeploy: this.detail.toDeploy, // 关联发布
                    toCmdb: this.detail.toCmdb, // 关联配置项
                    toService: this.detail.toService // 关联服务
                }
            }
        },

        data() {
            return {
                detail: {
                    // serialNumber: ''
                },

                index: 0,
                loading: true,
                activeName: "detailForm",
                tabViews: [
                    { name: "表单明细", index: "detailForm" },
                    { name: "配置属性", index: "configProperties" },
                    // { name: "配置关系", index: "detailRelation" },
                    { name: "历史版本", index: "HistoricEdition" },
                    { name: "操作记录", index: "OperationRecord" },

                    { name: "推荐知识", index: "RecommendKnowledge" },
                    { name: "条形码", index: "SquareYards" },
                    { name: "关联事件", index: "RelevancyEvent" },
                    { name: "关联问题", index: "RelevancyQue" },
                    { name: "关联变更", index: "RelevancyChange" },
                    { name: "关联发布", index: "RelevancyIssue" },
                ],
                tabActive: [
                    { path: '/eventAdd', title: '提交为事件'},
                    { path: '/changeAdd', title: '提交为变更'},
                    { path: '/problemAdd', title: '提交为问题'},
                    { path: '/deployAdd', title: '提交为发布'}
                ],
                status: "",   // 状态
                eventList:[],
                problemList:[],
                changeList:[],
                deployList:[]
            }
        },

        created() {
            this.getDetail()
            this.getEventList();
            this.getProblemList();
            this.getChangeList();
            this.getDeployList();
        },

        methods: {
            // 获取配置项详情
            getDetail(){
                services.cmdbDescribe({ serialNumber: this.serialNumber})
                    .then(res => {
                        this.detail =  res;
                        this.status = this.tableVal(res.status,this.cmdbStatus)
                        if (Object.keys(res.configProperties).length==0){
                            // console.log('不存在');
                            this.tabViews=this.tabViews.filter(item=>{
                                return item.name!=='配置属性'
                            })
                            // console.log(this.tabViews);

                        } else{
                            // console.log('存在');
                            // console.log(this.tabViews);
                        }
                    })
                    .catch(err => this.$message.error(err.message))
                    .finally(() => this.loading = false)
            },
            // 获取事件分类
            getEventList(){
                commonService.categoryList(this.eventType.id).then(res => {
                    this.eventList = res;
                })
            },
            // 获取问题分类
            getProblemList(){
                commonService.categoryList(this.problemType.id).then(res => {
                    this.problemList = res;
                })
            },
            // 获取变更分类
            getChangeList(){
                commonService.categoryList(this.changeType.id).then(res => {
                    this.changeList = res;
                    // console.log(this.changeList);
                })
            },
            // 获取发布分类
            getDeployList(){
                commonService.categoryList(this.deployType.id).then(res => {
                    this.deployList = res;
                })
            },

            // 设置配置项状态
            tableVal(value, arr) {
                if(!arr) return '无';
                if(arr && arr.length == 0) return "无";
                let res = arr.filter(item => item.id == value)
                if(!res.length) return '无'
                return res[0].cname;
            },

            // 切换组件
            handleClick(tab, event){
                this.index = tab.index
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    ul{
        li{
            margin-bottom:20px;
            display: flex;
            p{
                width:120px;
            }
        }
    }
    .zebra-item{
        span{
            padding-right: 10px;
        }
    }
</style>
